import { z } from 'zod';
import { sectionHasValue } from '../util';
export const baseIntegumentarySchema = z.object({
    details: z.array(z.string()).optional(),
    narrative: z.string().optional(),
    woundsPresent: z.string().optional(),
    wnl: z.boolean().optional(),
});
export const baseIntegumentaryRefined = baseIntegumentarySchema.refine((data) => sectionHasValue(data), {
    message: 'Mark as within normal limits if none applies',
    path: [],
});
